export default __webpack_public_path__ + "static/media/menuLatBG.ae7f7a3d.png";